import React from 'react';
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
const CallOutNudge = ({ callOutsTemplate }) => {
    const { title, bgColor, textColor } = callOutsTemplate || {};
    const Text = styled.div `
    color: ${textColor};
    background-color: ${bgColor};
    width: fit-content;
    background-color: ${() => hexToRgb(bgColor, 0.16)};
    padding: ${({ theme }) => `${theme.spacing.spacing10} ${theme.spacing.spacing20}`};
    margin-bottom: ${({ theme }) => theme.spacing.spacing10};
    ${({ theme }) => theme.typography.type102};
  }`;
    return (React.createElement(Text, { bgColor: bgColor, textColor: textColor }, title));
};
export default CallOutNudge;
